import React from 'react';
import { Box } from '@chakra-ui/react';
import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { PieChart as RechartsPieChart, Pie, Cell, Tooltip as PieTooltip, Legend as PieLegend } from 'recharts';
import { BarChart as RechartsBarChart, Bar, XAxis as BarXAxis, YAxis as BarYAxis, CartesianGrid as BarCartesianGrid, Tooltip as BarTooltip, Legend as BarLegend } from 'recharts';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const validateData = (data) => {
  return Array.isArray(data) && data.length > 0;
};

export const LineChart = ({ data }) => {
  if (!validateData(data)) {
    return <Box width="100%" height="100%" minHeight="300px" display="flex" alignItems="center" justifyContent="center">No data available</Box>;
  }

  return (
    <Box width="100%" height="100%" minHeight="300px">
      <ResponsiveContainer>
        <RechartsLineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="revenue" stroke="#8884d8" />
        </RechartsLineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export const PieChart = ({ data }) => {
  if (!validateData(data)) {
    return <Box width="100%" height="100%" minHeight="300px" display="flex" alignItems="center" justifyContent="center">No data available</Box>;
  }

  return (
    <Box width="100%" height="100%" minHeight="300px">
      <ResponsiveContainer>
        <RechartsPieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={80}
            fill="#8884d8"
            dataKey="count"
            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <PieTooltip />
          <PieLegend />
        </RechartsPieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export const BarChart = ({ data }) => {
  if (!validateData(data)) {
    return <Box width="100%" height="100%" minHeight="300px" display="flex" alignItems="center" justifyContent="center">No data available</Box>;
  }

  return (
    <Box width="100%" height="100%" minHeight="300px">
      <ResponsiveContainer>
        <RechartsBarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <BarCartesianGrid strokeDasharray="3 3" />
          <BarXAxis dataKey="name" />
          <BarYAxis />
          <BarTooltip />
          <BarLegend />
          <Bar dataKey="revenue" fill="#8884d8" />
        </RechartsBarChart>
      </ResponsiveContainer>
    </Box>
  );
}; 